import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.holdout.annotation');
import { HostListener, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-holdout-annotation',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.holdout.annotation/view.scss */
:host {
  display: block;
}

video {
  background: #09090b;
}`],
})
export class PageHoldoutAnnotationComponent implements OnInit {
    public snapshot: any = null;
    public loading: boolean = true;
    public busy: boolean = false;
    public message: string = '';
    public messageType: string = 'info';
    public reviewerId: string = '';
    public selectedId: string = '';
    public filter: string = 'ALL';
    public queueFilter: string = 'ALL_PENDING';
    public playbackRate: number = 1;
    public frameStep: number = 1;
    public reopenReason: string = '';
    public rejectReason: string = '';
    public registryReopenReason: string = '';
    public audit: any = null;
    public partition: any = null;
    public bulkSelected: {[candidateId: string]: boolean} = {};
    public bulkMetadata: any = {
        subject_id: '', location_id: '', event_id: '', capture_session_id: '',
    };
    public bulkPreview: any = null;
    public intakeSnapshot: any = null;
    public intakeFiles: File[] = [];
    public intakeUploading: boolean = false;
    public intakeProgress: number = 0;
    public intakeResultMessage: string = '';
    public intakeApprovalReason: string = '';
    public intakeMetadata: any = {
        subject_id: '',
        location_id: '',
        session_id: '',
        camera_id: '',
        recorded_at: '',
        data_source: '',
        prior_training_use: '',
        consent_scope: '',
        basic_behavior_type: '',
    };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init(this);
        await this.load();
    }

    private payload(json: any): any {
        return json?.data && typeof json.data === 'object' ? json.data : json;
    }

    private async request(endpoint: string, params: URLSearchParams, method: string = 'GET'): Promise<any> {
        const response = await fetch(`/wiz/api/page.holdout.annotation/${endpoint}?${params.toString()}`, { method });
        const json = await response.json();
        const payload = this.payload(json);
        if (!response.ok || Number(json?.code || response.status) >= 400) {
            throw new Error(payload?.message || json?.message || '요청을 처리하지 못했습니다.');
        }
        return payload;
    }

    public async load(candidateId: string = ''): Promise<void> {
        this.loading = true;
        try {
            const params = new URLSearchParams();
            if (candidateId || this.selectedId) params.set('candidate_id', candidateId || this.selectedId);
            this.snapshot = await this.request('workflow_snapshot', params);
            this.reviewerId = String(
                this.snapshot?.authenticated_reviewer_id || ''
            );
            this.selectedId = String(this.snapshot?.selected?.candidate_id || '');
            this.audit = await this.request('calibration_preflight', new URLSearchParams());
            this.partition = this.snapshot?.partition_registry || null;
            this.intakeSnapshot = await this.request('independent_intake_snapshot', new URLSearchParams());
        } catch (error: any) {
            this.message = error?.message || '검수 큐를 불러오지 못했습니다.';
            this.messageType = 'error';
        }
        this.loading = false;
        await this.service.render();
    }

    public records(): any[] {
        const rows = Array.isArray(this.snapshot?.records) ? this.snapshot.records : [];
        return rows.filter((row: any) => {
            const status = String(row?.status || 'PENDING');
            const ai = row?.ai_recommendation || {};
            const memberships = Array.isArray(row?.queue_memberships)
                ? row.queue_memberships
                : [row?.queue_type].filter(Boolean);
            if (this.queueFilter === 'ALL_PENDING' && !['PENDING', 'IN_REVIEW'].includes(status)) return false;
            if (
                this.queueFilter === 'WORKFLOW_VALIDATION_30'
                && !row?.workflow_validation_batch_id
            ) return false;
            if (
                this.queueFilter !== 'ALL_PENDING'
                && this.queueFilter !== 'WORKFLOW_VALIDATION_30'
                && !memberships.includes(this.queueFilter)
            ) return false;
            if (this.filter === 'ALL') return true;
            if (this.filter === 'PENDING') return status === 'PENDING' || status === 'IN_REVIEW';
            if (this.filter === 'DISAGREEMENT') return !!row?.human_final_label && row.human_final_label !== ai.label;
            if (this.filter === 'HIGH_EVENT') return this.finite(ai.event_risk_score) !== null && Number(ai.event_risk_score) >= 0.75;
            if (this.filter === 'LOW_RAW_HIGH_SHADOW') return this.finite(ai.raw_model_risk_score) !== null && this.finite(ai.shadow_peak_score) !== null && Number(ai.raw_model_risk_score) < 0.55 && Number(ai.shadow_peak_score) >= 0.75;
            if (this.filter === 'OCCLUSION') return (row.tags || []).some((tag: string) => ['PARTIAL_OCCLUSION', 'OUT_OF_FRAME', 'PERSON_TRACK_INTERRUPTED'].includes(tag));
            if (this.filter === 'BED_MAT') return (row.tags || []).includes('BED_OR_MAT_LANDING');
            if (this.filter === 'SEALABLE') return row?.status === 'APPROVED' && row?.seal_validation?.passed === true;
            if (this.filter === 'DUPLICATE') return row?.duplicate_suspected === true;
            if (this.filter === 'PARTITION_BLOCKED') return (row?.seal_validation?.blockers || []).some((blocker: any) => String(blocker?.code || blocker) === 'PARTITION_BLOCKED') || (row?.seal_validation?.partition_leaks || []).length > 0;
            if (this.filter === 'CALIBRATION_ELIGIBLE') return row?.data_usage === 'CALIBRATION_ELIGIBLE';
            if (this.filter === 'REVIEW_ONLY') return row?.review_only === true || row?.data_usage === 'REVIEW_ONLY';
            if (this.filter === 'TRAINING_OVERLAP') return row?.data_usage === 'TRAINING_OVERLAP';
            if (this.filter === 'PROVENANCE_UNKNOWN') return row?.independence_status === 'PROVENANCE_UNKNOWN' || row?.data_usage === 'PROVENANCE_UNKNOWN';
            if (this.filter === 'WORKFLOW_VALIDATION') return !!row?.workflow_validation_batch_id;
            return status === this.filter;
        });
    }

    private finite(value: any): number | null {
        if (value === null || value === undefined || value === '') return null;
        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : null;
    }

    public queueOptions(): any[] {
        return [
            ['ALL_PENDING', '전체 미검수'],
            ['FALL_CANDIDATES', '낙상 후보'],
            ['NON_FALL_HARD_NEGATIVES', '정상 hard-negative'],
            ['NEAR_FALL_CANDIDATES', 'Near-fall 후보'],
            ['LOW_QUALITY_REVIEW', '저품질·가림'],
            ['WORKFLOW_VALIDATION_30', '우선 검수 30 · workflow 확인'],
        ].map((item: string[]) => ({ key: item[0], label: item[1] }));
    }

    public queueStat(queue: string, key: string = 'total'): number {
        const stats = this.snapshot?.summary?.queue_stats || {};
        if (queue === 'ALL_PENDING') {
            if (key === 'total') return Number(this.snapshot?.summary?.pending || 0) + Number(this.snapshot?.summary?.in_review || 0);
            return Number(this.snapshot?.summary?.[key] || 0);
        }
        if (queue === 'WORKFLOW_VALIDATION_30') {
            const rows = (this.snapshot?.records || []).filter(
                (row: any) => !!row?.workflow_validation_batch_id
            );
            if (key === 'total') return rows.length;
            if (key === 'reviewed') return rows.filter(
                (row: any) => !!row?.human_final_label
            ).length;
            if (key === 'approved') return rows.filter(
                (row: any) => row?.status === 'APPROVED' || row?.status === 'SEALED'
            ).length;
            if (key === 'sealed') return rows.filter(
                (row: any) => row?.status === 'SEALED'
            ).length;
            return 0;
        }
        return Number(stats?.[queue]?.[key] || 0);
    }

    public intakeBehaviorTypes(): any[] {
        return [
            ['NORMAL_SIT', '정상 앉기'],
            ['NORMAL_LIE', '정상 눕기'],
            ['FAST_SIT', '빠르게 앉기'],
            ['KNEELING', '무릎 꿇기'],
            ['PICKING_OBJECT', '바닥 물건 줍기'],
            ['BED_TRANSFER', '침대 이동'],
            ['STAND_UP', '의자·침대에서 일어나기'],
            ['EXERCISE_OR_STRETCHING', '운동·스트레칭'],
            ['NEAR_FALL_RECOVERED', '비틀거림 후 회복'],
            ['WALL_SUPPORTED_RECOVERY', '벽을 잡고 균형 회복'],
            ['FALL', '실제 낙상'],
            ['LOW_QUALITY_OR_OCCLUDED', '저품질·가림'],
            ['OTHER', '기타'],
        ].map((item: string[]) => ({ key: item[0], label: item[1] }));
    }

    public intakeTargetRows(): any[] {
        const labels: {[key: string]: string} = {
            FALL: '독립 FALL',
            NON_FALL: '독립 NON_FALL',
            NEAR_FALL: '독립 NEAR_FALL',
            LOW_QUALITY: '독립 저품질',
            SUBJECT_GROUPS: '독립 subject',
            VIDEO_GROUPS: '독립 video',
            LOCATION_GROUPS: '독립 location',
        };
        const targets = this.intakeSnapshot?.targets || {};
        return Object.keys(labels).map((key: string) => ({
            key,
            label: labels[key],
            ...(targets?.[key] || { current: 0, target: 0, remaining: 0, met: false }),
        }));
    }

    public intakeMetadataComplete(): boolean {
        return [
            'subject_id', 'location_id', 'session_id', 'camera_id',
            'recorded_at', 'data_source', 'prior_training_use',
            'consent_scope', 'basic_behavior_type',
        ].every((field: string) => String(this.intakeMetadata?.[field] || '').trim());
    }

    public async onIntakeFilesSelected(event: any): Promise<void> {
        const allowed = new Set(['mp4', 'mov', 'avi', 'mkv', 'webm']);
        this.intakeFiles = Array.from(event?.target?.files || []).filter((file: any) => {
            const extension = String(file?.name || '').split('.').pop()?.toLowerCase() || '';
            return allowed.has(extension);
        }) as File[];
        this.intakeResultMessage = this.intakeFiles.length
            ? `${this.intakeFiles.length}개 영상을 선택했습니다. 사람 정답은 생성되지 않습니다.`
            : '지원 영상 파일을 선택해주세요.';
        await this.service.render();
    }

    private parseUploadResponse(response: any): any {
        if (typeof response === 'string') {
            try { return JSON.parse(response); } catch (_error) {
                return { code: 500, data: { message: response } };
            }
        }
        return response || {};
    }

    public async submitIndependentIntake(): Promise<void> {
        if (this.intakeUploading || !this.intakeFiles.length) return;
        if (!this.intakeMetadataComplete()) {
            this.intakeResultMessage = '독립성 판단에 필요한 intake metadata를 모두 입력해주세요.';
            return this.service.render();
        }
        this.intakeUploading = true;
        this.intakeProgress = 0;
        let completed = 0;
        const failures: string[] = [];
        for (let index = 0; index < this.intakeFiles.length; index += 1) {
            const file: any = this.intakeFiles[index];
            const metadata = {
                ...this.intakeMetadata,
                recorded_at: this.intakeMetadata.recorded_at
                    ? new Date(this.intakeMetadata.recorded_at).toISOString()
                    : '',
                upload_relative_path: file?.webkitRelativePath || file?.name || '',
                source_video_id: file?.webkitRelativePath || file?.name || '',
            };
            const form = new FormData();
            form.append('video', file);
            form.append('metadata', JSON.stringify(metadata));
            try {
                const raw: any = await this.service.file.upload(
                    '/wiz/api/page.holdout.annotation/register_independent_intake',
                    form,
                    async (percent: number) => {
                        this.intakeProgress = Math.round(
                            ((index + Math.max(0, Math.min(100, percent)) / 100) / this.intakeFiles.length) * 100
                        );
                        await this.service.render();
                    },
                );
                const response = this.parseUploadResponse(raw);
                const payload = this.payload(response);
                if (Number(response?.code || 200) >= 400) {
                    throw new Error(payload?.message || response?.message || '등록 실패');
                }
                this.intakeSnapshot = payload?.snapshot || this.intakeSnapshot;
                completed += 1;
            } catch (error: any) {
                failures.push(`${file?.name || '영상'}: ${error?.message || '등록 실패'}`);
            }
        }
        this.intakeUploading = false;
        this.intakeProgress = 100;
        this.intakeResultMessage = failures.length
            ? `${completed}건 등록 · ${failures.length}건 실패 — ${failures.slice(0, 3).join(' / ')}`
            : `${completed}건 등록을 완료했습니다. provenance가 미완전하면 PROVENANCE_UNKNOWN으로 차단됩니다.`;
        if (!failures.length) this.intakeFiles = [];
        try {
            this.intakeSnapshot = await this.request('independent_intake_snapshot', new URLSearchParams());
            const params = new URLSearchParams();
            if (this.selectedId) params.set('candidate_id', this.selectedId);
            this.snapshot = await this.request('workflow_snapshot', params);
            this.partition = this.snapshot?.partition_registry || this.partition;
        } catch (_error) { }
        await this.service.render();
    }

    public intakeStatusClass(status: string): string {
        if (status === 'INDEPENDENT_VERIFIED') return 'bg-emerald-100 text-emerald-800';
        if (status === 'DUPLICATE_BLOCKED') return 'bg-rose-100 text-rose-800';
        if (status === 'PROVENANCE_UNKNOWN') return 'bg-amber-100 text-amber-800';
        return 'bg-zinc-100 text-zinc-700';
    }

    public intakeEvidence(intake: any): string[] {
        const decision = intake?.independence || {};
        const rows = [
            ...(decision?.blockers || []),
            ...(decision?.warnings || []),
            ...(decision?.review_signals || []),
        ];
        return Array.from(new Set(rows.map(
            (row: any) => String(row?.code || row || '')
        ).filter(Boolean)));
    }

    public async approveIntakeWarnings(intake: any): Promise<void> {
        if (
            this.busy
            || intake?.independence_status !== 'INDEPENDENT_WITH_WARNINGS'
        ) return;
        if (!this.intakeApprovalReason.trim()) {
            return this.fail('독립성 경고 승인 사유를 입력해주세요.');
        }
        this.busy = true;
        try {
            const params = new URLSearchParams();
            params.set('intake_id', String(intake?.intake_id || ''));
            params.set('reason', this.intakeApprovalReason.trim());
            const result = await this.request(
                'approve_intake_warnings',
                params,
                'POST',
            );
            this.intakeSnapshot = result?.snapshot || this.intakeSnapshot;
            this.intakeApprovalReason = '';
            await this.load(this.selectedId);
            this.message = '관리자 감사 로그와 함께 독립성 경고를 승인했습니다.';
            this.messageType = 'success';
        } catch (error: any) {
            this.fail(error?.message || '독립성 경고를 승인하지 못했습니다.');
        }
        this.busy = false;
        await this.service.render();
    }

    public selectQueue(queue: string): void {
        this.queueFilter = queue;
        const first = this.records()[0];
        if (first) this.select(first);
    }

    public selected(): any {
        const rows = Array.isArray(this.snapshot?.records) ? this.snapshot.records : [];
        return rows.find((row: any) => String(row?.candidate_id || '') === this.selectedId) || this.snapshot?.selected || null;
    }

    public select(row: any): void {
        this.selectedId = String(row?.candidate_id || '');
        const selected = this.selected();
        if (selected) this.snapshot.selected = selected;
        setTimeout(() => this.seekReviewStart(), 0);
    }

    public selectedIndex(): number {
        const rows = this.records();
        return Math.max(0, rows.findIndex((row: any) => String(row?.candidate_id || '') === this.selectedId));
    }

    public moveCandidate(delta: number): void {
        const rows = this.records();
        if (!rows.length) return;
        const index = Math.max(0, rows.findIndex((row: any) => String(row?.candidate_id || '') === this.selectedId));
        this.select(rows[(index + delta + rows.length) % rows.length]);
    }

    public videoUrl(): string {
        return this.selectedId ? `/wiz/api/page.holdout.annotation/candidate_video?candidate_id=${encodeURIComponent(this.selectedId)}` : '';
    }

    public reviewStart(): number {
        return Math.max(0, Number(this.selected()?.segment_start || 0) - 2);
    }

    public reviewEnd(): number {
        const row = this.selected();
        const fps = Number(row?.candidate?.video_fps || 0);
        const frames = Number(row?.candidate?.video_frame_count || 0);
        const duration = fps > 0 && frames > 0 ? frames / fps : Number.POSITIVE_INFINITY;
        return Math.min(duration, Number(row?.segment_end || 0) + 2);
    }

    public onVideoLoaded(video: HTMLVideoElement): void {
        video.playbackRate = this.playbackRate;
        video.currentTime = this.reviewStart();
    }

    public onVideoTime(video: HTMLVideoElement): void {
        if (!video.paused && video.currentTime > this.reviewEnd()) {
            video.pause();
            video.currentTime = this.reviewEnd();
        }
    }

    public video(): HTMLVideoElement | null {
        return document.getElementById('holdout-review-video') as HTMLVideoElement;
    }

    public seekReviewStart(): void {
        const video = this.video();
        if (video) video.currentTime = this.reviewStart();
    }

    public setRate(rate: number): void {
        this.playbackRate = rate;
        const video = this.video();
        if (video) video.playbackRate = rate;
    }

    public togglePlay(): void {
        const video = this.video();
        if (!video) return;
        if (video.paused) {
            if (video.currentTime >= this.reviewEnd()) video.currentTime = this.reviewStart();
            video.play().catch(() => undefined);
        } else video.pause();
    }

    public stepFrame(direction: number): void {
        const video = this.video();
        const fps = Number(this.selected()?.candidate?.video_fps || 30) || 30;
        if (!video) return;
        video.pause();
        video.currentTime = Math.max(0, Math.min(video.duration || Number.POSITIVE_INFINITY, video.currentTime + direction * this.frameStep / fps));
    }

    public score(value: any): string {
        const number = this.finite(value);
        return number !== null ? `${Math.round(number * 100)}%` : '미산출';
    }

    public readinessLabels(row: any): string[] {
        const rawBlockers = Array.isArray(row?.seal_validation?.blockers)
            ? row.seal_validation.blockers : [];
        if (!rawBlockers.length && row?.seal_validation?.passed) return ['봉인 조건 충족'];
        const labels: {[key: string]: string} = {
            AUTO_ANALYSIS_INCOMPLETE: '자동 분석 필요',
            HUMAN_LABEL_REQUIRED: '사람 라벨 필요',
            SUBJECT_LOCATION_REQUIRED: 'subject/location 필요',
            EVENT_ID_REQUIRED: 'event_id 필요',
            MOMENTS_REQUIRED: '주요 시점 필요',
            DUPLICATE_RESOLUTION_REQUIRED: '중복 해결 필요',
            PARTITION_BLOCKED: 'partition 차단',
            REVIEWER_REQUIRED: '검수자 저장 필요',
            HUMAN_REVIEW_METADATA_REQUIRED: '검수 metadata 필요',
            AUTO_SEGMENT_REQUIRED: '분석 구간 복원 필요',
            PARTITION_LEAK: 'partition 중복 해결 필요',
            PARTITION_REGISTRY_UNSEALED: 'partition registry 봉인 필요',
            PARTITION_MEMBERSHIP_MISSING: 'promotion_holdout registry 등록 필요',
            PARTITION_MEMBERSHIP_UNCOMMITTED: 'promotion_holdout metadata 확인 필요',
            INDEPENDENCE_NOT_VERIFIED: '독립성 검증 필요',
            CALIBRATION_USAGE_BLOCKED: 'calibration 용도 차단',
            PROVENANCE_BLOCKED: 'provenance 확인 필요',
            SOURCE_HASH_CONFLICT: 'source hash 충돌 해결 필요',
            SOURCE_HASH_REQUIRED: 'source SHA-256 생성 필요',
            PARTITION_MEMBERSHIP_HASH_MISMATCH: 'registry source hash 불일치',
        };
        return rawBlockers.map((blocker: any) => {
            const code = String(blocker?.code || blocker || '');
            return String(blocker?.message || labels[code] || code);
        });
    }

    public recentValues(field: string): string[] {
        const source = this.snapshot?.recent_metadata || {};
        const direct = Array.isArray(source?.[field]) ? source[field] : [];
        const reviewerRows = Array.isArray(source?.[this.reviewerId])
            ? source[this.reviewerId] : [];
        return Array.from(new Set([
            ...direct,
            ...reviewerRows.map((row: any) => row?.[field]).filter(Boolean),
        ])).slice(0, 10);
    }

    public applySuggestions(): void {
        const row = this.selected();
        if (!row || row.status === 'SEALED') return;
        row.subject_id = row.subject_id || row.subject_id_suggestion || row?.candidate?.subject_id_suggestion || '';
        row.location_id = row.location_id || row.location_id_suggestion || row?.candidate?.location_id_suggestion || '';
        row.event_id = row.event_id || row.event_id_suggestion || row?.candidate?.event_id_suggestion || '';
    }

    public toggleBulk(row: any, event?: Event): void {
        if (event) event.stopPropagation();
        this.bulkSelected[String(row?.candidate_id || '')] = !this.bulkSelected[String(row?.candidate_id || '')];
        this.bulkPreview = null;
    }

    public bulkIds(): string[] {
        return Object.keys(this.bulkSelected).filter((key: string) => this.bulkSelected[key]);
    }

    public selectVisibleForBulk(): void {
        this.records().forEach((row: any) => {
            if (row?.status !== 'SEALED') this.bulkSelected[String(row.candidate_id)] = true;
        });
        this.bulkPreview = null;
    }

    public clearBulk(): void {
        this.bulkSelected = {};
        this.bulkPreview = null;
    }

    public selectSameVideoForBulk(): void {
        const row = this.selected();
        if (!row) return;
        (this.snapshot?.records || []).forEach((candidate: any) => {
            if (candidate?.status !== 'SEALED' && candidate?.source_video_id === row.source_video_id) {
                this.bulkSelected[String(candidate.candidate_id)] = true;
            }
        });
        this.bulkPreview = null;
    }

    public selectSameEventForBulk(): void {
        const row = this.selected();
        if (!row) return;
        (this.snapshot?.records || []).forEach((candidate: any) => {
            const sameSuggestion = row.event_id_suggestion
                && candidate?.event_id_suggestion === row.event_id_suggestion;
            const sameSession = row.capture_session_id
                && candidate?.capture_session_id === row.capture_session_id;
            if (candidate?.status !== 'SEALED' && (sameSuggestion || sameSession)) {
                this.bulkSelected[String(candidate.candidate_id)] = true;
            }
        });
        this.bulkPreview = null;
    }

    public async previewBulkMetadata(): Promise<void> {
        if (this.busy) return;
        if (!this.reviewerId.trim()) return this.fail('검수자 ID를 입력해주세요.');
        if (!this.bulkIds().length) return this.fail('일괄 적용 대상을 선택해주세요.');
        const metadata = Object.fromEntries(
            Object.entries(this.bulkMetadata).filter(([_key, value]) => String(value || '').trim())
        );
        if (!Object.keys(metadata).length) return this.fail('적용할 metadata를 입력해주세요.');
        this.busy = true;
        try {
            const params = new URLSearchParams();
            params.set('candidate_ids', this.bulkIds().join(','));
            params.set('metadata', JSON.stringify(metadata));
            params.set('reviewer_id', this.reviewerId.trim());
            this.bulkPreview = await this.request('bulk_metadata_preview', params, 'POST');
            this.message = `${this.bulkPreview?.count || 0}건의 적용 대상을 확인했습니다. 아직 저장되지 않았습니다.`;
            this.messageType = 'info';
        } catch (error: any) { this.fail(error?.message || '일괄 적용 미리보기를 만들지 못했습니다.'); }
        this.busy = false;
        await this.service.render();
    }

    public async applyBulkMetadata(): Promise<void> {
        if (this.busy || !this.bulkPreview?.preview_token) return;
        this.busy = true;
        try {
            const params = new URLSearchParams();
            params.set('preview_token', this.bulkPreview.preview_token);
            params.set('reviewer_id', this.reviewerId.trim());
            this.snapshot = await this.request('bulk_metadata_apply', params, 'POST');
            this.partition = this.snapshot?.partition_registry || this.partition;
            this.bulkPreview = null;
            this.clearBulk();
            this.message = '확인한 대상에 metadata를 일괄 적용했습니다.';
            this.messageType = 'success';
        } catch (error: any) { this.fail(error?.message || '일괄 metadata를 적용하지 못했습니다.'); }
        this.busy = false;
        await this.service.render();
    }

    public setLabel(label: string): void {
        const row = this.selected();
        if (!row || row.status === 'SEALED') return;
        row.human_final_label = label;
        row.tags = [];
    }

    public tagOptions(): string[] {
        const row = this.selected();
        if (row?.human_final_label === 'FALL') return this.snapshot?.schema?.fall_tags || [];
        if (row?.human_final_label === 'NON_FALL') return this.snapshot?.schema?.non_fall_tags || [];
        if (row?.human_final_label === 'NEAR_FALL_RECOVERED') return this.snapshot?.schema?.fall_tags || [];
        return [];
    }

    public toggleTag(tag: string): void {
        const row = this.selected();
        if (!row || row.status === 'SEALED') return;
        const tags = new Set(Array.isArray(row.tags) ? row.tags : []);
        if (tags.has(tag)) tags.delete(tag); else tags.add(tag);
        row.tags = Array.from(tags);
    }

    public setMoment(key: string): void {
        const row = this.selected();
        const video = this.video();
        if (!row || !video || row.status === 'SEALED') return;
        if (!row.moments) row.moments = {};
        row.moments[key] = Number(video.currentTime.toFixed(3));
    }

    public clearMoment(key: string): void {
        const row = this.selected();
        if (row?.moments && row.status !== 'SEALED') delete row.moments[key];
    }

    public momentKeys(): any[] {
        return [
            ['balance_lost', '균형 상실'], ['descent_start', '하강 시작'], ['impact', '충격'],
            ['lowest_point', '최저점'], ['recovery_start', '회복 시작'], ['stable', '안정'],
        ].map((item: string[]) => ({ key: item[0], label: item[1] }));
    }

    private annotationPayload(): any {
        const row = this.selected() || {};
        return {
            human_final_label: row.human_final_label || '', tags: row.tags || [], moments: row.moments || {},
            subject_id: row.subject_id || '', location_id: row.location_id || '', source_video_id: row.source_video_id || '',
            event_id: row.event_id || '', capture_session_id: row.capture_session_id || '', camera_id: row.camera_id || '',
            segment_start: row.segment_start, segment_end: row.segment_end, sensor_quality: row.sensor_quality || '', notes: row.notes || '',
        };
    }

    public async save(): Promise<void> {
        const row = this.selected();
        if (!row || this.busy) return;
        if (!this.reviewerId.trim()) return this.fail('검수자 ID를 입력해주세요.');
        this.busy = true;
        try {
            const params = new URLSearchParams();
            params.set('candidate_id', row.candidate_id);
            params.set('reviewer_id', this.reviewerId.trim());
            params.set('annotation', JSON.stringify(this.annotationPayload()));
            this.snapshot = await this.request('save_annotation', params, 'POST');
            this.selectedId = row.candidate_id;
            this.message = '검수 내용을 저장했습니다. 승인 후 봉인할 수 있습니다.';
            this.messageType = 'success';
        } catch (error: any) { this.fail(error?.message || '저장하지 못했습니다.'); }
        this.busy = false;
        await this.service.render();
    }

    public async transition(action: string): Promise<void> {
        const row = this.selected();
        if (!row || this.busy) return;
        if (!this.reviewerId.trim()) return this.fail('검수자 ID를 입력해주세요.');
        this.busy = true;
        try {
            const params = new URLSearchParams();
            params.set('candidate_id', row.candidate_id);
            params.set('reviewer_id', this.reviewerId.trim());
            params.set('action', action);
            params.set('reason', this.rejectReason);
            this.snapshot = await this.request('transition_annotation', params, 'POST');
            this.selectedId = row.candidate_id;
            this.message = action === 'SEAL' ? '독립 holdout 샘플을 봉인했습니다.' : '상태를 변경했습니다.';
            this.messageType = 'success';
        } catch (error: any) { this.fail(error?.message || '상태를 변경하지 못했습니다.'); }
        this.busy = false;
        await this.service.render();
    }

    public async reopen(): Promise<void> {
        const row = this.selected();
        if (!row || this.busy) return;
        if (!this.reviewerId.trim() || !this.reopenReason.trim()) return this.fail('재개방 검수자와 사유를 입력해주세요.');
        this.busy = true;
        try {
            const params = new URLSearchParams();
            params.set('candidate_id', row.candidate_id);
            params.set('reviewer_id', this.reviewerId.trim());
            params.set('reason', this.reopenReason.trim());
            this.snapshot = await this.request('reopen_annotation', params, 'POST');
            this.selectedId = row.candidate_id;
            this.reopenReason = '';
            this.message = '감사 로그를 남기고 샘플을 재개방했습니다.';
            this.messageType = 'success';
        } catch (error: any) { this.fail(error?.message || '재개방하지 못했습니다.'); }
        this.busy = false;
        await this.service.render();
    }

    public async runCalibration(): Promise<void> {
        if (this.busy) return;
        this.busy = true;
        try {
            const result = await this.request('run_calibration', new URLSearchParams(), 'POST');
            this.message = `Calibration ${result?.report?.status || '완료'} · promotion_allowed=false`;
            this.messageType = 'success';
        } catch (error: any) { this.fail(error?.message || 'Calibration 실행이 차단되었습니다.'); }
        this.busy = false;
        await this.load(this.selectedId);
    }

    public async auditPartitionRegistry(): Promise<void> {
        if (this.busy) return;
        this.busy = true;
        try {
            const result = await this.request('partition_registry_audit', new URLSearchParams());
            this.partition = { ...(result?.registry || {}), audit: result?.audit };
            this.message = result?.audit?.passed
                ? 'Partition registry 감사 조건을 통과했습니다. 검수자 확인 후 봉인할 수 있습니다.'
                : 'Partition registry에 누수 또는 누락 metadata가 있어 봉인이 차단됩니다.';
            this.messageType = result?.audit?.passed ? 'success' : 'error';
        } catch (error: any) { this.fail(error?.message || 'Partition registry 감사를 실행하지 못했습니다.'); }
        this.busy = false;
        await this.service.render();
    }

    public async sealPartitionRegistry(): Promise<void> {
        if (this.busy) return;
        if (!this.reviewerId.trim()) return this.fail('Partition 봉인 검수자 ID를 입력해주세요.');
        this.busy = true;
        try {
            const params = new URLSearchParams();
            params.set('reviewer_id', this.reviewerId.trim());
            const result = await this.request('seal_partition_registry', params, 'POST');
            this.partition = { ...(result?.registry || {}), audit: result?.audit };
            this.message = 'Partition registry를 해시와 감사 로그로 봉인했습니다.';
            this.messageType = 'success';
        } catch (error: any) { this.fail(error?.message || 'Partition registry 봉인이 차단되었습니다.'); }
        this.busy = false;
        await this.load(this.selectedId);
    }

    public async reopenPartitionRegistry(): Promise<void> {
        if (this.busy) return;
        if (!this.reviewerId.trim() || !this.registryReopenReason.trim()) {
            return this.fail('Partition 재개방 검수자와 사유를 입력해주세요.');
        }
        this.busy = true;
        try {
            const params = new URLSearchParams();
            params.set('reviewer_id', this.reviewerId.trim());
            params.set('reason', this.registryReopenReason.trim());
            const result = await this.request('reopen_partition_registry', params, 'POST');
            this.partition = { ...(result?.registry || {}), audit: result?.audit };
            this.registryReopenReason = '';
            this.message = '사유와 감사 로그를 남기고 Partition registry를 재개방했습니다.';
            this.messageType = 'success';
        } catch (error: any) { this.fail(error?.message || 'Partition registry를 재개방하지 못했습니다.'); }
        this.busy = false;
        await this.load(this.selectedId);
    }

    private fail(message: string): void {
        this.message = message;
        this.messageType = 'error';
    }

    @HostListener('document:keydown', ['$event'])
    public onKey(event: KeyboardEvent): void {
        const target = event.target as HTMLElement;
        const typing = ['INPUT', 'TEXTAREA', 'SELECT'].includes(String(target?.tagName || ''));
        if (typing) return;
        const key = event.key;
        if (key === '1') this.setLabel('FALL');
        else if (key === '2') this.setLabel('NON_FALL');
        else if (key === '3') this.setLabel('NEAR_FALL_RECOVERED');
        else if (key === '4') this.setLabel('UNCERTAIN');
        else if (key === '5') this.setLabel('EXCLUDE');
        else if (key.toLowerCase() === 's') this.save();
        else if (key.toLowerCase() === 'n') this.moveCandidate(1);
        else if (key.toLowerCase() === 'p') this.moveCandidate(-1);
        else if (key === ' ') { event.preventDefault(); this.togglePlay(); }
        else if (key === 'ArrowLeft') { event.preventDefault(); this.stepFrame(-1); }
        else if (key === 'ArrowRight') { event.preventDefault(); this.stepFrame(1); }
    }
}

export default PageHoldoutAnnotationComponent;